var map = {
	"./bach-green.jpg": 3225,
	"./beethoven-green.jpg": 1002,
	"./beethoven-orange.jpg": 7729,
	"./dschinghis-khan-green.jpg": 7111,
	"./dschinghis-khan-orange.jpg": 1346,
	"./falco-orange.jpg": 4824,
	"./mozart-green.jpg": 5467,
	"./mozart-orange.jpg": 2583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7927;